import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import CleanFrontDeskList from './components/CleanFrontDeskList';

const { Cell } = ResponsiveGrid;

const CleanFrontDesk = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="清潔前台"
        // description="清潔列表"
        breadcrumbs={[
          {
            name: '清潔工作',
          },
          {
            name: '清潔前台',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <CleanFrontDeskList />
    </Cell>
  </ResponsiveGrid>
);

export default CleanFrontDesk;
